export default __webpack_public_path__ + "static/media/arbonne-mobile.181ecbba.jpg";